module.exports = __webpack_public_path__ + "img/resale.74e5610b.svg";